import { render } from "./ExpenseForm.vue?vue&type=template&id=b86b43ca&scoped=true"
import script from "./ExpenseForm.vue?vue&type=script&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&lang=js"

import "./ExpenseForm.vue?vue&type=style&index=0&id=b86b43ca&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86b43ca"]])

export default __exports__